import { Controller } from "@hotwired/stimulus";

// Drives the sidebar label picker: keeps hidden label_type_ids inputs in sync
// with the panel's checkboxes, then submits the patch form on dropdown close
// (only when the selection changed) or when a chip is removed.
export default class extends Controller {
  static targets = ["panel", "hiddenInputs"];
  static values = {
    inputName: String,
    autoSubmit: { type: Boolean, default: true },
  };

  onSelectionChange() {
    this._syncHiddenInputs();
  }

  // Snapshot on open so close can decide whether anything actually changed.
  onDropdownShown() {
    this._openSnapshot = this._currentValues().sort();
  }

  onDropdownHidden() {
    if (this._openSnapshot == null) return;

    const before = this._openSnapshot;
    this._openSnapshot = null;
    if (this._valuesEqual(before, this._currentValues().sort())) return;

    this._submit();
  }

  removeChip(event) {
    const checkbox = this._checkboxFor(event.currentTarget.dataset.labelId);
    if (checkbox) checkbox.checked = false;

    // Removing a chip submits now. Drop any open snapshot so the dropdown's
    // outside-click close (chips live outside the panel) doesn't submit again.
    this._openSnapshot = null;
    this._syncHiddenInputs();
    this._submit();
  }

  _checkboxFor(id) {
    return this._checkboxes().find((cb) => cb.value === String(id)) || null;
  }

  _checkboxes() {
    if (!this.hasPanelTarget) return [];

    return Array.from(
      this.panelTarget.querySelectorAll(".filter-option-list__checkbox"),
    );
  }

  _currentValues() {
    return this._checkboxes().filter((cb) => cb.checked).map((cb) => cb.value);
  }

  _syncHiddenInputs() {
    if (!this.hasHiddenInputsTarget) return;

    this.hiddenInputsTarget.replaceChildren();
    this._currentValues().forEach((value) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = this.inputNameValue;
      input.value = value;
      this.hiddenInputsTarget.appendChild(input);
    });
  }

  _valuesEqual(a, b) {
    return a.length === b.length && a.every((value, i) => value === b[i]);
  }

  _submit() {
    if (!this.autoSubmitValue) return;

    const form = this.element.querySelector("form");
    if (form) form.requestSubmit();
  }
}
